import InternalStaticAnchorMissionList from 'models/application/anchor/types/internalStatic/types/MissionList';

export default class InternalStaticAnchorMissionListService {
	toModel(anchor) {
		return new InternalStaticAnchorMissionList(anchor);
	}
}
